<div class="share-partner-picker">
    <div class="pick-section mb-2">
        <label class="pick-checkbox">
            <input type="checkbox" [(ngModel)]="byCustomer" [ngModelOptions]="{ standalone: true }" />
            <span class="pick-title">{{'contract_share_partner.by_customer' | translate}}</span>
        </label>
        <div class="pick-content" *ngIf="byCustomer">
            <div class="pick-label">{{'contract_share_partner.search_partner_hint' | translate}}</div>
            <div class="editable-row">
                <nz-input-group [nzSuffix]="suffixPartyInput2">
                    <input nz-input [(ngModel)]="inputPartyValue" (input)="onChangePartySignSearch($event)"
                        [nzAutocomplete]="autoPartySearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                          'contract_share_partner.enter_partner_customer' | translate
                        }}" id="inputParty" />
                    <nz-autocomplete #autoPartySearching>
                        <nz-auto-option *ngFor="let party of filteredPartyOptions" (selectionChange)="
                                            autocompletePartySelected($event, party)
                                          " [nzValue]="''">
                            <div class="d-flex">
                                <mat-icon class="mr-2">account_circle</mat-icon>
                                <span style="line-height: 20px">
                                    {{ party.name }} -
                                    {{
                                    party.taxCode && party.taxCode.length > 0
                                    ? party.taxCode
                                    : party.certificateNo
                                    }}
                                </span>
                            </div>
                            <div class="d-flex">
                                <mat-icon class="mr-2">contact_mail</mat-icon>
                                <span style="line-height: 20px">
                                    <span *ngIf="party.email">{{ party.email }} -</span>
                                    {{ party.phone }}
                                </span>
                            </div>
                            <hr style="margin: 0; padding: 0" />
                        </nz-auto-option>
                    </nz-autocomplete>
                </nz-input-group>
                <ng-template #suffixPartyInput2>
                    <nz-spin *ngIf="nzCheckLoadingParty2" nzSimple [nzIndicator]="indicatorPartyInput2"></nz-spin>
                </ng-template>
                <ng-template #indicatorPartyInput2><i class="nz-icon-font" nz-icon nzType="loading"
                        style="font-size: 24px"></i>
                </ng-template>
            </div>
            <div class="pick-list-header">
                {{'contract_share_partner.customer_list' | translate}} (<span class="text-primary">{{selectedCustomers.length}}</span>)
            </div>
            <div class="table-container">
                <nz-table #customerTable nzBordered [nzData]="selectedCustomers" [nzShowPagination]="false"
                    [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                        <tr>
                            <th class="text-center" nzWidth="35px">
                                {{
                                "view_document_information.table_headers.signingApostropheContractUnit.no"
                                | translate
                                }}
                            </th>
                            <th class="text-center" nzWidth="65%">
                                {{
                                "view_document_information.table_headers.signingApostropheContractUnit.member"
                                | translate
                                }}
                            </th>
                            <th class="text-center" nzWidth="150px">
                                {{ 'contract_share_partner.view_permission' | translate }}
                            </th>
                            <th class="text-center" nzWidth="47px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of customerTable.data; let i = index" class="editable-row">
                            <td class="text-center">{{ i + 1 }}</td>
                            <td class="word-break-line">
                                <div class="editable-cell">
                                    <div class="row-icon"> {{ data.name }} <span *ngIf="data.email"> - {{ data.email
                                            }}</span><span *ngIf="data.phone"> - {{ data.phone }}</span></div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center justify-content-center cursor-pointer"
                                    [matMenuTriggerFor]="menuCustomerPermission">
                                    <div>
                                        <span *ngIf="data.permission == 'FILE'">{{'contract_share_partner.view_file_contract' |
                                            translate}}</span>
                                        <span *ngIf="data.permission == 'FULL'">{{'contract_share_partner.view_detail_contract' |
                                            translate}}</span>
                                    </div>
                                    <div>
                                        <button mat-icon-button>
                                            <mat-icon>keyboard_arrow_down</mat-icon>
                                        </button>
                                        <mat-menu #menuCustomerPermission="matMenu">
                                            <button mat-menu-item
                                                (click)="setPermission(data, 'FILE')"
                                                [ngClass]="{'active': data.permission == 'FILE'}">
                                                {{'contract_share_partner.view_file_contract' | translate}}
                                            </button>
                                            <button mat-menu-item
                                                (click)="setPermission(data, 'FULL')"
                                                [ngClass]="{'active': data.permission == 'FULL'}">
                                                {{'contract_share_partner.view_detail_contract' | translate}}
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </td>
                            <td class="td-nz-icon text-center">
                                <button (click)="onClickDeleteElementRecordParty(data.enterpriseId, data.customerId)"
                                    aria-label="Clear" mat-button mat-icon-button matSuffix style="color: #ee0033"
                                    type="button">
                                    <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>

    <div class="pick-section">
        <label class="pick-checkbox">
            <input type="checkbox" [(ngModel)]="byGroup" (ngModelChange)="onToggleByGroup($event)" [ngModelOptions]="{ standalone: true }" />
            <span class="pick-title">{{'contract_share_partner.by_customer_group' | translate}}</span>
        </label>
        <div class="pick-content" *ngIf="byGroup">
            <div class="pick-label">{{'contract_share_partner.group_name' | translate}}</div>
            <div class="editable-row">
                <nz-input-group [nzSuffix]="suffixGroupInput">
                    <input nz-input [(ngModel)]="inputGroupValue" (input)="onChangeGroupSearch($event)"
                        [nzAutocomplete]="autoGroupSearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                          'contract_share_partner.enter_group_name' | translate
                        }}" id="inputGroup" />
                    <nz-autocomplete #autoGroupSearching>
                        <nz-auto-option *ngFor="let group of filteredGroupOptions" (selectionChange)="
                                            autocompleteGroupSelected($event, group)
                                          " [nzValue]="''">
                            <div class="d-flex">
                                <mat-icon class="mr-2">group</mat-icon>
                                <span style="line-height: 20px">{{ group.name }}</span>
                            </div>
                            <hr style="margin: 0; padding: 0" />
                        </nz-auto-option>
                    </nz-autocomplete>
                </nz-input-group>
                <ng-template #suffixGroupInput>
                    <nz-spin *ngIf="nzCheckLoadingGroup" nzSimple [nzIndicator]="indicatorGroupInput"></nz-spin>
                </ng-template>
                <ng-template #indicatorGroupInput><i class="nz-icon-font" nz-icon nzType="loading"
                        style="font-size: 24px"></i>
                </ng-template>
            </div>
            <div class="pick-list-header">
                {{'contract_share_partner.customer_group_list' | translate}} (<span class="text-primary">{{selectedGroups.length}}</span>)
            </div>
            <div class="table-container">
                <nz-table #groupTable nzBordered [nzData]="selectedGroups" [nzShowPagination]="false"
                    [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                    <thead>
                        <tr>
                            <th class="text-center" nzWidth="35px">
                                {{
                                "view_document_information.table_headers.signingApostropheContractUnit.no"
                                | translate
                                }}
                            </th>
                            <th class="text-center" nzWidth="65%">
                                {{ 'contract_share_partner.customer_group' | translate }}
                            </th>
                            <th class="text-center" nzWidth="150px">
                                {{ 'contract_share_partner.view_permission' | translate }}
                            </th>
                            <th class="text-center" nzWidth="47px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of groupTable.data; let i = index" class="editable-row">
                            <td class="text-center">{{ i + 1 }}</td>
                            <td class="word-break-line">
                                <div class="editable-cell">
                                    <div class="row-icon"> {{ data.name }}</div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center justify-content-center cursor-pointer"
                                    [matMenuTriggerFor]="menuGroupPermission">
                                    <div>
                                        <span *ngIf="data.permission == 'FILE'">{{'contract_share_partner.view_file_contract' |
                                            translate}}</span>
                                        <span *ngIf="data.permission == 'FULL'">{{'contract_share_partner.view_detail_contract' |
                                            translate}}</span>
                                    </div>
                                    <div>
                                        <button mat-icon-button>
                                            <mat-icon>keyboard_arrow_down</mat-icon>
                                        </button>
                                        <mat-menu #menuGroupPermission="matMenu">
                                            <button mat-menu-item
                                                (click)="setPermission(data, 'FILE')"
                                                [ngClass]="{'active': data.permission == 'FILE'}">
                                                {{'contract_share_partner.view_file_contract' | translate}}
                                            </button>
                                            <button mat-menu-item
                                                (click)="setPermission(data, 'FULL')"
                                                [ngClass]="{'active': data.permission == 'FULL'}">
                                                {{'contract_share_partner.view_detail_contract' | translate}}
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </td>
                            <td class="td-nz-icon text-center">
                                <button (click)="onClickDeleteElementRecordGroup(data.groupId)" aria-label="Clear"
                                    mat-button mat-icon-button matSuffix style="color: #ee0033" type="button">
                                    <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>
